import React, { useEffect, useRef } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import EmailIcon from "@mui/icons-material/Email";
export default function ShareProperty({ property, getShareUrl, onClose }) {
  const modalRef = useRef();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose]);
  const shareUrl = getShareUrl(property);
  const encodedUrl = encodeURIComponent(shareUrl);
  return (
    <div style={styles.modalOverlay}>
      <div ref={modalRef} style={styles.modal}>
        <h3 style={styles.modalTitle}>Share Property</h3>
        <div style={styles.copyInputGroup}>
          <input readOnly value={shareUrl} style={styles.copyInputField} />
          <button
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              alert("Link copied to clipboard!");
            }}
            style={styles.copyIconBtn}
            title="Copy Link"
          >
            <ContentCopyIcon style={{ fontSize: 18, color: "#007BFF" }} />
          </button>
        </div>
        <div style={styles.shareButtonGroup}>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#25D366" }}
            onClick={() =>
              window.open(`https://wa.me/?text=${encodedUrl}`, "_blank")
            }
            title="WhatsApp"
          >
            <WhatsAppIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#E1306C" }}
            onClick={() => {
              navigator.clipboard.writeText(shareUrl);
              alert("Link copied! Paste it into Instagram.");
            }}
            title="Instagram"
          >
            <InstagramIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#1877F2" }}
            onClick={() =>
              window.open(
                `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
                "_blank"
              )
            }
            title="Facebook"
          >
            <FacebookIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#1DA1F2" }}
            onClick={() =>
              window.open(
                `https://twitter.com/intent/tweet?url=${encodedUrl}`,
                "_blank"
              )
            }
            title="Twitter"
          >
            <TwitterIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#0077B5" }}
            onClick={() =>
              window.open(
                `https://www.linkedin.com/shareArticle?url=${encodedUrl}`,
                "_blank"
              )
            }
            title="LinkedIn"
          >
            <LinkedInIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#0088CC" }}
            onClick={() =>
              window.open(`https://t.me/share/url?url=${encodedUrl}`, "_blank")
            }
            title="Telegram"
          >
            <TelegramIcon style={styles.iconStyle} />
          </button>
          <button
            style={{ ...styles.shareBtn, backgroundColor: "#EA4335" }}
            onClick={() =>
              window.open(`mailto:?subject=Check this property&body=${encodedUrl}`)
            }
            title="Email"
          >
            <EmailIcon style={styles.iconStyle} />
          </button>
        </div>
      </div>
    </div>
  );
}
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px 30px",
    borderRadius: "10px",
    textAlign: "center",
    width: "360px",
    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
  },
  modalTitle: {
    marginBottom: "10px",
    fontSize: "20px",
  },
  copyInputGroup: {
    display: "flex",
    alignItems: "center",
    border: "1px solid #ccc",
    borderRadius: "6px",
    padding: "0 8px",
    backgroundColor: "#F9F9F9",
    marginBottom: "20px",
  },
  copyInputField: {
    flex: 1,
    padding: "10px",
    border: "none",
    outline: "none",
    fontSize: "14px",
    backgroundColor: "transparent",
  },
  copyIconBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  shareButtonGroup: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "12px",
  },
  shareBtn: {
    width: "44px",
    height: "44px",
    borderRadius: "50%",
    border: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "background 0.3s ease",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  },
  iconStyle: {
    color: "white",
    fontSize: 20,
  },
};